import React, { useEffect, useState } from 'react'
import { useResErrors } from '../../../hooks'
import { CarService, SalesService } from '../../../lib/api'
import { CircularProgress } from '../../../asterX-UI/Loaders'
import CarSelectionCard from '../../Mobile/Car/CarSelectionCard'
import { Divider, Grid, makeStyles } from '@material-ui/core'
import { Modal } from '../../../asterX-UI/Modals'
import CarData from '../../Mobile/Car/CarData'
import { GRAY_COLORS } from '../../../asterX-UI'
import { NotFound } from '../../NotFound'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12,
    width: '100%'
  },
  rowText: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    color: GRAY_COLORS[700],
    fontSize: 14,
    fontWeight: 600
  }
}))

export const WorkListSelectionHistory = ({ saleId, tradeInCarVin }) => {
  const classes = useStyles()
  const [isLoading, setIsLoading] = useState(false)
  const [history, setHistory] = useState({
    demonstratedCars: [],
    selectedCars: []
  })
  const [activeCar, setActiveCar] = useState(null)
  const [tradeInCar, setTradeInCar] = useState(null)
  const { standardCheck } = useResErrors()
  useEffect(() => {
    if (saleId) {
      getPastSelection()
    }
  }, [])

  useEffect(() => {
    if (tradeInCarVin) {
      getCarByVin()
    }
  }, [tradeInCarVin])
  const getPastSelection = async () => {
    setIsLoading(true)
    await SalesService.getPastSelection(saleId).then(res =>
      standardCheck(res, () => {
        setHistory(res.data)
      })
    )
    setIsLoading(false)
  }
  const handleCarClick = car => {
    setActiveCar(car)
  }
  const getDemonstrationResults = vin => {
    const car = history?.demonstratedCars?.find(car => car.vin === vin)
    if (car) {
      return {
        resultConfiguration: car?.resultConfiguration,
        resultExternal: car?.resultExternal,
        resultPrice: car?.resultPrice,
        resultTechnical: car?.resultTechnical,
        resultTestDrive: car?.resultTestDrive,
        resultTestDriveExpress: car?.resultTestDriveExpress,
        isNotDemonstrated: car?.isNotDemonstrated,
        comment: car?.comment
      }
    }
    return null
  }

  const getCarByVin = async () => {
    setIsLoading(true)

    await CarService.getCarByVin(tradeInCarVin).then(response =>
      standardCheck(response, () => {
        setTradeInCar(response.data)
      })
    )

    setIsLoading(false)
  }

  return (
    <Grid item container className={classes.root}>
      {isLoading ? (
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      ) : (
        <Grid item container justifyContent="flex-start" spacing={6}>
          {tradeInCar && (
            <Grid
              item
              xs={12}
              className={classes.rowText}
              style={{ marginTop: 10 }}
            >
              Trade-In авто
            </Grid>
          )}

          {tradeInCar && (
            <Grid item xs={12} sm={6} md={4}>
              <CarSelectionCard
                car={tradeInCar}
                onClick={() => handleCarClick(tradeInCar)}
              />
            </Grid>
          )}
          {tradeInCar && (
            <div className={classes.rowText}>
              <Divider />
            </div>
          )}
          {history?.demonstratedCars?.length > 0 && (
            <Grid
              item
              xs={12}
              className={classes.rowText}
              style={{ marginTop: 10 }}
            >
              Демонстрация авто
            </Grid>
          )}

          {history?.demonstratedCars?.map(car => (
            <Grid item xs={12} sm={6} md={4}>
              <CarSelectionCard car={car} onClick={() => handleCarClick(car)} />
            </Grid>
          ))}
          {history?.demonstratedCars?.length > 0 && (
            <div className={classes.rowText}>
              <Divider />
            </div>
          )}

          {history?.selectedCars?.length > 0 && (
            <Grid item xs={12} className={classes.rowText}>
              Подбор авто
            </Grid>
          )}
          {history?.selectedCars?.map(car => (
            <Grid item xs={12} sm={6} md={4}>
              <CarSelectionCard car={car} onClick={() => handleCarClick(car)} />{' '}
            </Grid>
          ))}
          {history?.selectedCars?.length === 0 &&
            history?.demonstratedCars?.length === 0 && (
              <NotFound title="Нет данных" />
            )}
        </Grid>
      )}
      {activeCar?.id && (
        <Modal fullScreen open={activeCar} onClose={() => handleCarClick(null)}>
          <CarData
            vin={activeCar.vin}
            demonstrationResults={getDemonstrationResults(activeCar.vin)}
            onClose={() => handleCarClick(null)}
          />
        </Modal>
      )}
    </Grid>
  )
}
